import { render, staticRenderFns } from "./TbodyEx.vue?vue&type=template&id=2bcad767&scoped=true&"
import script from "./TbodyEx.vue?vue&type=script&lang=js&"
export * from "./TbodyEx.vue?vue&type=script&lang=js&"
import style0 from "./TbodyEx.vue?vue&type=style&index=0&id=2bcad767&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcad767",
  null
  
)

export default component.exports